module.exports = __webpack_public_path__ + "static/media/package.fd8ff550.svg";